import { useContext, useState } from 'react';
import { Button } from '../ui/Button';
import { Dialog } from '../ui/Dialog';
import { Input } from '../ui/Input';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { UserContext } from '../../../src/context/UserProvider';
import { UsersClient } from '../../../src/services/UsersClient';
import { toast } from 'react-toastify';

type NormChangerDialogType = {
    open: boolean;
    setOpenModal: () => void;
    deviationFromFuelConsumptionPercentage: number;
    userId: string;
};

export const NormChangerDialog = ({ open, setOpenModal, deviationFromFuelConsumptionPercentage, userId }: NormChangerDialogType) => {
    const [norm, setNorm] = useState<number>(deviationFromFuelConsumptionPercentage);
    const user = useContext(UserContext);
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: (data: { userId: string; deviationFromFuelConsumptionPercentage: number }) => {
            return UsersClient(user).setFuelConsumptionPercentageDeviation(data.userId, data.deviationFromFuelConsumptionPercentage);
        },
        onSuccess: async () => {
            setOpenModal();
            queryClient.invalidateQueries();
            toast.success('Norm succesvol aangepast');
        },
        onError: (error) => {
            console.error(error);
            toast.error('Er is iets misgegaan bij het aanpassen van de norm');
        },
    });

    const onSubmit = async () => {
        mutation.mutate({ userId, deviationFromFuelConsumptionPercentage: norm });
    };

    return (
        <Dialog open={open} onClose={setOpenModal}>
            <Dialog.Title className="mb-3">Wijzig toegestane norm</Dialog.Title>

            <Input
                placeholder="Norm"
                type="number"
                required
                value={norm}
                onChange={(e) => {
                    setNorm(parseInt(e.target.value));
                }}
            />

            <div className="flex justify-end pt-6">
                <Button loading={false} onClick={onSubmit} className="relative">
                    Opslaan
                </Button>
            </div>
        </Dialog>
    );
};
